import * as BABYLON from '@babylonjs/core';
import '@babylonjs/core/Particles/index'
import BaseObject from "../BaseObject";

export default class Fire extends BaseObject
{
    show()
    {
        let self = this;

        let path = process.env.VUE_APP_FOLDER + (process.env.VUE_APP_FOLDER.slice(-1) === '/' ? '' : '/');
        BABYLON.ParticleHelper.BaseAssetsUrl = path + 'js/babylon/';
        BABYLON.ParticleSystemSet.BaseAssetsUrl = path + 'js/babylon/';


        // Fire!
        if (!self.fire)
        {
            // https://doc.babylonjs.com/how_to/particlehelper
            // https://github.com/BabylonJS/Babylon.js/tree/master/assets/particles/systems
            BABYLON.ParticleHelper.CreateAsync("fire", this.scene, false).then((set) =>
            {
                var p = new BABYLON.Vector3(10, 2, -40);
                set.systems[0].emitter = p;
                set.systems[1].emitter = p;
                set.systems[2].emitter = p;
                set.systems[3].emitter = p;
                set.start();
                self.fire = set;
            });
        }
        else
        {
            self.fire.start();
        }

        // Smoke
        if (!self.smoke)
        {
            BABYLON.ParticleHelper.CreateAsync("smoke", this.scene, false).then((set) =>
            {
                set.systems[0].emitter = new BABYLON.Vector3(0, 7, 0);
                set.start();
                self.smoke = set;
            });
        }
        else
        {
            self.smoke.start();
        }
    }

    hide()
    {
        let self = this;

        // Feuer entfernen
        //this.fire.dispose();
        //this.fire = false;

        // Rauch entfernen
        //this.smoke.dispose();
        //this.smoke = false;


        if (self.fire)
        {

            // Feuer anhalten
            for (let id in this.fire.systems)
            {
                if (this.fire.systems.hasOwnProperty(id))
                {
                    // Emitter anhalten
                    this.fire.systems[id].stop();
                    // erzeuges Elemente entfernen
                    this.fire.systems[id].reset();
                }
            }

            // Rauch anhalten
            for (let id in this.smoke.systems)
            {
                if (this.smoke.systems.hasOwnProperty(id))
                {
                    // Emitter anhalten
                    this.smoke.systems[id].stop();
                    // erzeuges Elemente entfernen
                    this.smoke.systems[id].reset();
                }
            }

        }

    }
}
